import { Control, Controller, useWatch } from "react-hook-form";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import Select from "react-select";
import { selectStyle, selectTheme } from "../../styles/selectStyles";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import SelectOption from "../global/SelectOption";
import { DictionaryType } from "../../types";
import ValidateError from "../global/ValidateError";
import MultiSearchableSelect from "../global/MultiSearchableSelect";
import { useGetAllClubsByNameQuery } from "../../lib/redux/services/sections/Clubs";
import { MembershipRequest } from "../../types/request/membership";
import {
  useGetAllCourtsByNameQuery,
  useGetCourtsNamesQuery,
} from "../../lib/redux/services/sections/Courts";
import { daysOptions } from "../../data/options";
import { cn, getMinutesBetweenTimes } from "../../utils/utils";
import { useGetAllWalletServicesQuery } from "../../lib/redux/services/sections/Customers";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { CircleHelp } from "lucide-react";
import { CURRENCY } from "../../constants";
type Props = {
  control: Control<MembershipRequest, any>;
  errors: any;
  getValues: any;
  index: number;
  setOverlappingRows: any;
  watch: any;
  eventType: "edit" | "view";
  setSelectedGroups: any;
  selectedGroups: any;
  overlappingRows: any;
  setValue: any;
};
export const handleStartRequest = (fields: string[], watch: any) => {
  const turnOff = fields.some((field) => {
    return (
      //@ts-ignore
      watch(field) === "" ||
      //@ts-ignore
      watch(field) === null ||
      watch(field)?.length === 0 ||
      //@ts-ignore
      watch(field) === undefined
    );
  });
  return turnOff;
};

function MembershipBenefit({
  control,
  errors,
  selectedGroups,
  getValues,
  setOverlappingRows,
  setValue,
  index,
  overlappingRows,
  setSelectedGroups,
  watch,
  eventType,
}: Props) {
  const { pricing, inputs, customers, placeHolders }: DictionaryType =
    useGetDictionary();

  const orgId = useSelector((state: any) => state.user.user?.org_id);
  const timeRangeType = watch(`benefits.${index}.time_range_type`);
  const allowed_service_ids = watch(`benefits.${index}.allowed_service_ids`);
  const allowed_court_ids = watch(`benefits.${index}.allowed_court_ids`);
  const allowed_club_id = watch(`benefits.${index}.allowed_club_id`);
  const fromTime = watch(`benefits.${index}.from_time`);
  const toTime = watch(`benefits.${index}.to_time`);
  const selectedDays = watch(`benefits.${index}.selects_days`);
  const [currentSelectedGroup, setCurrentSelectedGroup] = useState("");
  useEffect(() => {});
  const addSelectedGroup = (group: any) => {
    // Create a new Set from the old one and add the new element
    setSelectedGroups((prevSet: any) => {
      const newSet = new Set(prevSet);
      newSet.add(group);
      return newSet;
    });
  };
  const removeSelectedGroup = (group: any) => {
    // Create a new Set from the old one and add the new element
    setSelectedGroups((prevSet: any) => {
      const newSet = new Set(prevSet);

      newSet.delete(group);
      return newSet;
    });
  };
  const discountType = useWatch({
    control,
    name: `benefits.${index}.discount_type`,
    defaultValue: "percentage", // Provide a default value in case `discount` is undefined
  });
  const { options }: DictionaryType = useGetDictionary();
  const benifits = watch("benefits");
  console.log(benifits);

  const currentbenifits = benifits?.[index];

  const currentDays = currentbenifits?.selects_days;
  console.log(currentDays);

  const updatedDaysOptions =
    currentbenifits && currentDays
      ? currentDays.includes(7)
        ? daysOptions(options).filter((day) => day.value == 7)
        : currentDays.length > 0
        ? daysOptions(options).filter((day) => day.value != 7)
        : daysOptions(options)
      : daysOptions(options);
  const handleOption = (options: any) => {
    let allOtherSelectedItems: number[] = [];
    console.log(benifits);
    let selectedClub = watch(`benefits.${index}.allowed_club_id`);
    benifits.map((benifit: any, listIndex: number) => {
      let itemClub = benifit.allowed_club_id;
      console.log(itemClub);

      if (listIndex !== index && itemClub == selectedClub) {
        allOtherSelectedItems = [
          ...allOtherSelectedItems,
          ...benifit.allowed_service_ids,
        ];
      }
    });
    console.log(allOtherSelectedItems);

    let filteredOptions = options.filter(
      (option: any) =>
        !(
          allOtherSelectedItems.includes(option.id) &&
          option.groupKey === "Events and academy"
        )
    );
    if (currentSelectedGroup !== "") {
      filteredOptions = filteredOptions.filter(
        (option: any) => option.groupKey === currentSelectedGroup
      );
    }

    return filteredOptions;
  };
  console.log(overlappingRows);

  useEffect(() => {
    if (overlappingRows.includes(index)) {
      setOverlappingRows((prev: any) =>
        prev.filter((item: any) => item !== index)
      );
    }
  }, [
    timeRangeType,
    allowed_service_ids,
    allowed_court_ids,
    fromTime,
    toTime,
    timeRangeType,
    selectedDays,
    allowed_club_id,
  ]);
  return (
    <div
      className={cn(
        "flex flex-col gap-8 w-full pb-5 border-b-2 border-b-[#ccc] border-dashed",
        overlappingRows.includes(index) && "bg-primaryRed/10"
      )}
    >
      <h3 className="font-bold text-lg text-primary dark:text-white ">
        {customers.membership_benefit} {index + 1}
      </h3>
      <div className=" grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 grid-rows-1 gap-4 w-full ">
        <div className="w-full col-span-1 min-w-[200px]">
          <label className="block text-sm mb-2">
            Allowed club <span className="text-red-500">*</span>
          </label>
          <Controller
            control={control}
            name={`benefits.${index}.allowed_club_id`}
            rules={{ required: true }}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSearchableSelect
                  fetchFunction={useGetAllClubsByNameQuery}
                  field={field}
                  valueKey="id"
                  isDisabled={eventType === "view"}
                  isMulti={false}
                />
                {error && <ValidateError />}
              </>
            )}
          />
        </div>
        <div className="w-full col-span-1 min-w-[200px]">
          <label className="block text-sm mb-2">
            Allowed services <span className="text-red-500">*</span>
          </label>
          <Controller
            control={control}
            name={`benefits.${index}.allowed_service_ids`}
            rules={{ required: true }}
            render={({ field, fieldState: { error } }) => (
              <>
                <MultiSearchableSelect
                  fetchFunction={useGetAllWalletServicesQuery}
                  dependOn={[orgId]}
                  isGroupList={true}
                  AfterLoading={(options: any) => {
                    const selectedServices = watch(
                      `benefits.${index}.allowed_service_ids`
                    );
                    console.log(selectedServices);
                    console.log(options);

                    const selectedGroupKey = options.find(
                      (option: any) => option.id === selectedServices[0]
                    )?.groupKey;
                    selectedGroupKey &&
                      setCurrentSelectedGroup(selectedGroupKey);
                  }}
                  groupOptions={{
                    OrginizeBy: "group_name",
                    groupTitleKey: "group_name",
                    listGroupKey: "services",
                  }}
                  handleOption={handleOption}
                  field={field}
                  changeCallBack={(
                    selected: {
                      groupKey: string;
                    }[]
                  ) => {
                    console.log(selected);
                    if (selected?.length === 0) {
                      removeSelectedGroup(currentSelectedGroup);
                    } else {
                      addSelectedGroup(selected[0]?.groupKey || "");
                    }
                    if (currentSelectedGroup === "Events and academy") {
                      setValue(`benefits.${index}.time_range_type`, "custom");
                      setValue(`benefits.${index}.allowed_court_ids`, []);
                      setValue(`benefits.${index}.from_time`, "");
                      setValue(`benefits.${index}.to_time`, "");
                      setValue(`benefits.${index}.selects_days`, []);
                    }
                    setCurrentSelectedGroup(selected[0]?.groupKey || "");
                  }}
                  valueKey="id"
                  pathParams={{
                    org_id: orgId,
                    type: "membership",
                  }}
                  isDisabled={eventType === "view"}

                  //  isDisabled={type == "view"}
                />
                {error && <ValidateError />}
              </>
            )}
          />
        </div>
        {currentSelectedGroup !== "Events and academy" && (
          <>
            {" "}
            <div className="w-full col-span-1 min-w-[200px]">
              <label className="block text-sm mb-2">
                Allowed Courts <span className="text-red-500">*</span>
              </label>
              <Controller
                control={control}
                name={`benefits.${index}.allowed_court_ids`}
                rules={{ required: true }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <MultiSearchableSelect
                      fetchFunction={useGetAllCourtsByNameQuery}
                      field={field}
                      valueKey="id"
                      pathParams={{
                        club_ids: [watch(`benefits.${index}.allowed_club_id`)],
                      }}
                      turnOff={handleStartRequest(
                        [`benefits.${index}.allowed_club_id`],
                        watch
                      )}
                      dependOn={[watch(`benefits.${index}.allowed_club_id`)]}
                      isDisabled={eventType === "view"}
                      isMulti={true}
                    />
                    {error && <ValidateError />}
                  </>
                )}
              />
            </div>
            <div className="w-full col-span-1 mobile:min-w-[200px]">
              <label className="block text-sm mb-2 text-primary dark:text-white">
                Select days
                <span className="text-red-500">*</span>
              </label>
              <Controller
                control={control}
                rules={{ required: true }}
                name={`benefits.${index}.selects_days`}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Select
                      menuPlacement="top"
                      isDisabled={eventType === "view"}
                      components={{
                        IndicatorSeparator: () => null,
                        ClearIndicator: () => null,
                        Option: SelectOption,
                      }}
                      {...field}
                      onChange={(selected) => {
                        return field.onChange(
                          //@ts-ignore
                          selected
                            ? //@ts-ignore
                              selected.map((option) => option.value)
                            : []
                        );
                      }}
                      value={
                        field.value
                          ? daysOptions(options).filter((option) =>
                              field.value!.includes(option.value)
                            )
                          : []
                      }
                      isMulti
                      styles={selectStyle}
                      classNamePrefix="react-select"
                      theme={selectTheme}
                      options={updatedDaysOptions}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder={placeHolders.select}
                    />
                    {error && <ValidateError />}
                  </>
                )}
              />
            </div>
          </>
        )}
        {/* <div className="w-full col-span-1 min-w-[200px]">
                 <label className="block text-sm mb-2">
            Allowed services  <span className="text-red-500">*</span>
        </label>
                                      <Controller
                              control={control}
                              name={`benefits.${index}.allowed_service_ids`}
                              rules={{ required: true }}
                              render={({ field,fieldState:{error} }) => (
                                <>
                                 <MultiSearchableSelect fetchFunction={useGetAllWalletServicesQuery} field={field} valueKey='id' pathParams={{
                                  org_id:orgId
                                 }} 
                                 isDisabled={eventType==='view'}
                                 
                                  //  isDisabled={type == "view"}
                                   />
                                   {error && <ValidateError/>}
                                </>
                              )}
                            />
                            </div> */}
      </div>
      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mobile:min-w-[200px]">
        {currentSelectedGroup !== "Events and academy" && (
          <div className="col-span-1 flex h-full items-center">
            <Tooltip
              id="range-tooltip"
              style={{
                backgroundColor: "#f3f3f3",
                color: "#1e1850",
                top: "0px",
                zIndex: 1000,
              }}
              place="top"
            />
            <Controller
              name={`benefits.${index}.time_range_type`}
              control={control}
              render={({ field }) => (
                <div className="flex flex-row items-center gap-4">
                  <div className=" flex items-center gap-1">
                    <label className=" font-bold text-primary dark:text-white whitespace-nowrap">
                      Range type
                    </label>
                    <span className="text-xs inline  ">
                      <CircleHelp
                        color="#d1d5db "
                        size={15}
                        className="cursor-context-menu"
                        data-tooltip-id="range-tooltip"
                        data-tooltip-html={
                          "Start and the end times during the selected days"
                        }
                      />
                    </span>
                  </div>

                  <RadioInput
                    value="full"
                    isDisabled={eventType === "view"}
                    label={"full"}
                    labelStyle="text-primary dark:text-white"
                    checked={field.value === "full"}
                    onChange={(value) => {
                      return field.onChange(value);
                    }}
                  />
                  <RadioInput
                    value="custom"
                    isDisabled={eventType === "view"}
                    label={"custom"}
                    labelStyle="text-primary dark:text-white"
                    checked={field.value === "custom"}
                    onChange={(value) => {
                      return field.onChange(value);
                    }}
                  />
                </div>
              )}
            />
          </div>
        )}
        {timeRangeType === "custom" &&
          currentSelectedGroup !== "Events and academy" && (
            <div className="w-full flex gap-2 col-span-1 mobile:min-w-[300px]">
              <div className="w-full flex-1">
                <Controller
                  control={control}
                  name={`benefits.${index}.from_time`}
                  rules={{ required: true }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Input
                        customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                        inputProps={{
                          ...field,
                          type: "time",
                          placeholder: inputs.start_time,
                          // readOnly:
                          //   currentType === "add player" ||
                          //   currentType == "view",
                        }}
                        label={inputs.start_time}
                      />
                      {error && <ValidateError />}
                    </>
                  )}
                />
              </div>

              <div className="w-full flex-1">
                <Controller
                  control={control}
                  name={`benefits.${index}.to_time`}
                  rules={{
                    required: true,
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <Input
                        customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                        inputProps={{
                          ...field,
                          type: "time",

                          placeholder: inputs.end_time,
                          // readOnly:
                          //   currentType === "add player" ||
                          //   currentType == "view",
                        }}
                        label={inputs.end_time}
                      />
                      {error && (
                        <ValidateError errorMessage={error?.message || ""} />
                      )}
                    </>
                  )}
                />
              </div>
            </div>
          )}
        <div className="col-span-1">
          <Controller
            name={`benefits.${index}.max_bookings_day`}
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Input
                  label={inputs.max_number_of_bookings_per_day}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.bookings}
                />
                {error && <ValidateError />}
              </>
            )}
          />
          {/* @ts-ignore */}
        </div>
        <div className="col-span-1">
          <Controller
            name={`benefits.${index}.max_bookings_month`}
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Input
                  label={inputs.max_number_of_bookings_per_month}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.bookings}
                />
                {error && <ValidateError />}
              </>
            )}
          />
          {/* @ts-ignore */}
          {errors.booking_days_in_advance && <ValidateError />}
        </div>
      </div>
      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 mobile:min-w-[200px]">
        {currentSelectedGroup !== "Events and academy" && (
          <div className="col-span-1">
            <Controller
              name={`benefits.${index}.max_booking_duration`}
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Input
                    label={inputs.max_duration_of_booking}
                    customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                    inputProps={{
                      ...field,
                      className:
                        "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                      type: "number",
                      onWheel: (e) => {
                        e.preventDefault();
                        //@ts-ignore
                        e.target.blur();
                      },
                      step: 0,
                    }}
                    title={"minutes"}
                  />
                  {error && <ValidateError />}
                </>
              )}
            />
            {/* @ts-ignore */}
            {errors.booking_days_in_advance && <ValidateError />}
          </div>
        )}
        <div className="col-span-1 flex h-full items-center">
          <Controller
            name={`benefits.${index}.discount_type`}
            control={control}
            render={({ field }) => (
              <div className="flex flex-row items-center gap-8">
                <label className=" font-bold text-primary dark:text-white">
                  {inputs.discount_type}
                </label>
                <RadioInput
                  value="value"
                  isDisabled={eventType === "view"}
                  label={inputs.value}
                  labelStyle="text-primary dark:text-white"
                  checked={field.value === "value"}
                  onChange={(value) => {
                    return field.onChange(value);
                  }}
                />
                <RadioInput
                  value="percentage"
                  isDisabled={eventType === "view"}
                  label={inputs.percentage}
                  labelStyle="text-primary dark:text-white"
                  checked={field.value === "percentage"}
                  onChange={(value) => {
                    return field.onChange(value);
                  }}
                />
              </div>
            )}
          />
        </div>
        <div className="col-span-1">
          <Controller
            name={`benefits.${index}.discount_value`}
            control={control}
            rules={{ required: false }}
            render={({ field, fieldState: { error } }) => (
              <>
                <Input
                  label={pricing.discount}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  inputProps={{
                    ...field,
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                  }}
                  title={discountType === "value" ? CURRENCY() : "%"}
                  isRequired={false}
                />
                {/* {error && <ValidateError/>} */}
              </>
            )}
          />
          {/* @ts-ignore */}
        </div>
        {currentSelectedGroup === "Private" && (
          <div className="w-full col-span-1">
            <label className="block text-sm mb-2">
              {inputs.application}
              <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name={`benefits.${index}.application`}
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <>
                  <Select
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    {...field}
                    styles={selectStyle}
                    classNamePrefix="react-select"
                    theme={selectTheme}
                    isDisabled={eventType === "view"}
                    options={[
                      {
                        label: inputs.full_booking_value,
                        value: "paid_amount",
                      },
                      { label: inputs.member_share, value: "member_share" },
                    ]}
                    onChange={(selected) =>
                      // @ts-ignore only
                      field.onChange(selected ? selected.value : null)
                    }
                    value={
                      [
                        {
                          label: inputs.full_booking_value,
                          value: "paid_amount",
                        },
                        { label: inputs.member_share, value: "member_share" },
                      ].find((option) => option.value === field.value) || null
                    }
                    placeholder={placeHolders.select}
                  />
                  {error && <ValidateError />}
                </>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default MembershipBenefit;
